import { render, staticRenderFns } from "./BalancePageMenuItem.vue?vue&type=template&id=650a4aa0&scoped=true"
import script from "./BalancePageMenuItem.vue?vue&type=script&lang=js"
export * from "./BalancePageMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650a4aa0",
  null
  
)

export default component.exports